import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import Approve_Self from "./components/Approve_Self";

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions,roles, user, location}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}/self`}>
				<Approve_Self regions={regions} roles={roles} user={user} initialDate={location?.state?.initialDate}/>
			</ErrorBoundaryRoute>


			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
